import PropTypes from 'prop-types';
import React from 'react';

const propertiesAsParagraphs = (data) => (Object.keys(data).map((key) => {
  const value = data[key];
  if (value === undefined) {
    return <p key={`${key}-${value}`}>{`${key}: undefined,`}</p>;
  } else if (typeof value === 'object' && value !== null) {
    return (
      <article key={`${key}-${value}`}>
        {`${key}: {`}
        <section className="ml4-sm">
          {propertiesAsParagraphs(value)}
        </section>
        {'},'}
      </article>
    );
  } else {
    return <p key={`${key}-${value}`}>{`${key}: ${value},`}</p>;
  }
}));

const TransactionBlob = ({ transaction, footers }) => (
  <article className="ml4-sm p2-sm body-4">
    {'Transaction: {'}
    <section className="ml4-sm">
      {propertiesAsParagraphs(transaction)}
    </section>
    {'}'}
    {footers && !!footers.length && <FooterJsonView footers={footers} />}
  </article>
);

const FooterJsonView = ({ footers }) => (
  <>
    ,<br />
    {'footer: {'}
    <section className="ml4-sm">
      {propertiesAsParagraphs(footers)}
    </section>
    {'}'}
  </>
);

FooterJsonView.defaultProps = {
  footers: [],
};

FooterJsonView.propTypes = {
  footers: PropTypes.arrayOf(PropTypes.string)
};

TransactionBlob.defaultProps = {
  footers: [],
};

TransactionBlob.propTypes = {
  footers: PropTypes.arrayOf(PropTypes.string),
  transaction: PropTypes.shape().isRequired
};

export default TransactionBlob;
